import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { PaymentReports } from '../../../wallet/DialogHistory';
import UserWallet from '../UserWallet';
import WalletEventsList from '../../../wallet/walletEvents/WalletEventsList';

function UserWalletEventsInfo({ userData }) {
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <>
      <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        ver wallet
      </Button>
      <DialogWalletEvents open={openDialog} onClose={setOpenDialog} userData={userData} />
    </>
  );
}

export default UserWalletEventsInfo;

function DialogWalletEvents({ open, onClose, userData }) {
  const [walletEvents, setWalletEvents] = useState([]);
  const handleClose = () => {
    onClose(false);
  };

  useEffect(() => {
    async function geWalletEvents() {
      await firestore
        .collection('walletEvents')
        .where('user_id', '==', userData.id)
        .orderBy('date', 'desc')
        .onSnapshot((queryS) => {
          const dat = [];
          queryS.forEach((doc) => {
            dat.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // console.log('datos del user', dat);
          setWalletEvents(dat);
        });
    }
    geWalletEvents();
  }, [userData]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      fullWidth
    >
      {/* <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
        Wallet del usuario
      </DialogTitle> */}
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <UserWallet userId={userData.id} />
          </Grid>
          <Grid item xs={12} md={9}>
            <WalletEventsList walletEvents={walletEvents} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
